import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../../redux/store';

interface PatientProtectedRouteProps {
  children: React.ReactElement;
}

export const PatientProtectedRoute = ({ children }: PatientProtectedRouteProps) => {
  const patientToken = useSelector((s: RootState) => s.patientAuth.patientToken);

  if (!patientToken) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};
